import { Pagination } from "@mui/material";
import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { blueMui, greyMui } from "@ryde/theme";

export const UserActionsHistoryColumnStyled = styled.div.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "user-actions-history-column",
  },
)`
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  width: 100%;

  .UserActionsHistory-ListSurface {
    flex: 1;
    min-height: 0;
    overflow: auto;
    padding: 8px 10px 8px 8px;
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .UserActionsHistory-Footer {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    padding: 8px 10px 10px 8px;
    border-top: 1px solid ${greyMui._300};
  }

  .UserActionsHistory-Footer .UserActionsHistory-FooterLeading {
    flex: 1;
    min-width: 0;
    display: flex;
    align-items: center;
  }

  .UserActionsHistory-Footer
    .UserActionsHistory-ClearButton.MuiButtonBase-root {
    flex-shrink: 0;
    min-height: 32px;
    min-width: 32px;
    padding: 4px 8px;
    font-size: 0.75rem;
    text-transform: none;
  }
`;

type PlaqueAccentProps = { $accent: string };

export const UserActionsHistoryPlaqueButtonStyled = styled.button.attrs<
  IStyledAttributes & { type: "button" }
>({
  [DATA_E2E_KEY]: "user-actions-history-plaque",
  type: "button",
})<PlaqueAccentProps>`
  appearance: none;
  margin: 0;
  width: 100%;
  text-align: start;
  font-family: inherit;
  cursor: pointer;
  display: grid;
  grid-template-columns: 112px minmax(0, 1fr) 68px;
  align-items: center;
  column-gap: 10px;
  min-height: 27px;
  background: linear-gradient(180deg, ${greyMui._50} 0%, ${greyMui._100} 100%);
  border: 1px solid ${greyMui._200};
  border-inline-start: 3px solid ${greyMui._500};
  border-radius: 8px;
  padding: 5px 9px 5px 6px;
  box-shadow: 0 1px 2px rgb(0 0 0 / 0.05);
  transition:
    background 0.15s ease,
    box-shadow 0.15s ease,
    border-color 0.15s ease;

  &:hover {
    background: ${greyMui._100};
    box-shadow: 0 2px 5px rgb(0 0 0 / 0.07);
    border-color: ${greyMui._300};
  }

  &:focus-visible {
    outline: 2px solid ${blueMui._600};
    outline-offset: 2px;
  }

  .UserActionsHistory-PlaqueWhen {
    margin: 0;
    font-size: 0.6875rem;
    font-weight: 500;
    line-height: 1.25;
    color: ${greyMui._600};
    font-variant-numeric: tabular-nums;
    letter-spacing: 0.02em;
    white-space: nowrap;
  }

  .UserActionsHistory-PlaqueCenter {
    margin: 0;
    min-width: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 6px;
    line-height: 1.25;
    overflow: hidden;
    font-size: 0.8125rem;
    font-weight: 600;
  }

  .UserActionsHistory-PlaqueDot {
    width: 7px;
    height: 7px;
    min-width: 7px;
    border-radius: 50%;
    background-color: ${({ $accent }) => $accent};
    flex-shrink: 0;
    box-shadow: 0 0 0 1px rgb(255 255 255 / 0.65) inset;
  }

  .UserActionsHistory-PlaqueUnboundGlyph {
    flex-shrink: 0;
    font-size: 11px;
    font-weight: 700;
    line-height: 1;
    user-select: none;
  }

  .UserActionsHistory-PlaqueLabel {
    flex: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: ${greyMui._700};
    font-weight: 600;
  }

  .UserActionsHistory-PlaqueAgo {
    flex-shrink: 0;
    color: ${greyMui._400};
    font-weight: 500;
    font-variant-numeric: tabular-nums;
    white-space: nowrap;
  }

  .UserActionsHistory-PlaqueId {
    justify-self: end;
    width: 100%;
    text-align: end;
    color: ${greyMui._500};
    font-weight: 500;
    font-variant-numeric: tabular-nums;
    white-space: nowrap;
  }
`;

export const UserActionsHistoryFooterPaginationStyled = styled(
  Pagination,
).attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "user-actions-history-footer-pagination",
})`
  .MuiPagination-ul {
    flex-wrap: wrap;
    justify-content: flex-start;
  }
`;
